import Utils from "../Utils";
import swaggerClient from "./../remote-client";

export default class BillsServiceImpl {
  callSaveAppointmentInvoiceInfo(
    officeId,
    appointmentId,
    invoiceNumber,
    invoiceDate,
    invoiceTotal
  ) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillOfficeWithOfficeIdAppointmentWithAppointmentIdInvoice_data(
            { officeId, appointmentId },
            swaggerClient.buildRequest({
              invoiceNumber,
              invoiceDate,
              invoiceTotal
            }),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  fetchBills(officeId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillsOfficeWithOfficeId(
            { officeId },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  fetchBillsByCro(officeId, cro) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.getBillWithCroOfficeWithOfficeIdProvidedServices(
            { officeId, cro },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  fetchBillsPayments(officeId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillsPaymentsOfficeWithOfficeId(
            { officeId },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  getBillsCount(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillsCountWithStateOfficeWithOfficeId(
            { officeId: payload.officeId, state: payload.state },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          if (result?.body) {
            return result.body.numberOfBills;
          }
          return 0;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  createBill(officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillOfficeWithOfficeId(
            {
              officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  uploadDocument(officeId, billId, document) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillWithBillIdOfficeWithOfficeIdDocument(
            {
              officeId,
              billId
            },
            swaggerClient.buildRequest({ document }),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  addDoneAppointment(billId, officeId, appointmentId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillWithBillIdOfficeWithOfficeIdAppointmentWithAppointmentIdDone(
            {
              billId,
              officeId,
              appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  addAcceptedAppointment(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillWithBillIdOfficeWithOfficeIdAppointmentWithAppointmentIdAccepted(
            {
              officeId: payload.officeId,
              billId: payload.billId,
              appointmentId: payload.appointmentId
            },
            swaggerClient.buildRequest({ deliveryDate: payload.deliveryDate }),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  addBillAppointments(billId, appointmentList) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillWithIdServices(
            {
              id: billId
            },
            swaggerClient.buildRequest(appointmentList),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  addBillDocument(billDocument) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillDocument(
            {},
            swaggerClient.buildRequest(billDocument),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  sendBill(officeId, billId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillWithBillIdOfficeWithOfficeIdSend(
            {
              billId,
              officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  fetchBillDetailsById(officeId, billId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.getBillWithBillIdOfficeWithOfficeId(
            {
              officeId,
              billId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  exportBillsPaymentsOfficeWithOfficeId(officeId, cro) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.postBillsWithCroOfficeWithOfficeIdPaymentsExport(
            { cro, officeId },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  callGetProvidedServiceById(officeId, appointmentId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.getBillOfficeWithOfficeIdAppointmentWithAppointmentId(
            {
              officeId,
              appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  removeAppointmentFromBill(officeId, billId, appointmentId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.deleteBillWithBillIdOfficeWithOfficeIdAppointmentWithAppointmentId(
            {
              officeId,
              billId,
              appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  callRemoveDocumentFromBill(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityBillsManagement.deleteBillWithBillIdOfficeWithOfficeIdDocumentWithDocumentId(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  callAddNoteToBill(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityBillsManagement.postBillWithBillIdOfficeWithOfficeIdNote(
            {
              billId: payload.billId,
              officeId: payload.officeId
            },
            swaggerClient.buildRequest(payload.billNote),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }

  addBillPrescriptionDocument(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityBillsManagement.postBillOfficeWithOfficeIdAppointmentWithAppointmentIdPrescription(
            {
              officeId: payload.officeId,
              appointmentId: payload.appointmentId
            },
            swaggerClient.buildRequest(payload.document),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }

  removeBillPrescriptionDocument(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityBillsManagement.deleteBillOfficeWithOfficeIdAppointmentWithAppointmentIdPrescription(
            {
              officeId: payload.officeId,
              appointmentId: payload.appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }

  addBillInvoiceDocument(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityBillsManagement.postBillOfficeWithOfficeIdAppointmentWithAppointmentIdInvoice(
            {
              officeId: payload.officeId,
              appointmentId: payload.appointmentId
            },
            swaggerClient.buildRequest(payload.document),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }

  removeBillInvoiceDocument(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityBillsManagement.deleteBillOfficeWithOfficeIdAppointmentWithAppointmentIdInvoice(
            {
              officeId: payload.officeId,
              appointmentId: payload.appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }

  callSaveAllInvoiceData(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityBillsManagement.postBillOfficeWithOfficeIdAppointmentWithAppointmentIdSaveAllInvoiceData(
            {
              officeId: payload.officeId,
              appointmentId: payload.appointmentId
            },
            swaggerClient.buildRequest(payload.invoiceData),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }

  callGenerateFascicoloBySingleDocuments(officeId, appointmentId) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityBillsManagement.postBillOfficeWithOfficeIdAppointmentWithAppointmentIdGenerateFascicoloBySingleDocuments(
            {
              officeId: officeId,
              appointmentId: appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }

  callGenerateFascicoloByBulkDocuments(billId, officeId) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityBillsManagement.postBillWithBillIdOfficeWithOfficeIdGenerateFascicoloByBulkDocuments(
            {
              billId: billId,
              officeId: officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }

  callCheckFascicoloGenerationByBulkDocuments(billId, officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(client => {
        return client.apis.HealthFacilityBillsManagement.postBillWithBillIdOfficeWithOfficeIdCheckFascicoloGenerationByBulkDocuments(
          {
            billId: billId,
            officeId: officeId
          },
          swaggerClient.buildRequest(),
          {}
        );
      })
      .then(result => {
        return result.body;
      })
      .catch(error => {
        return error;
      });
  }
}
